/* eslint-disable max-len */
import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';

import {disableScroll, enableScroll} from '../../utils/helpers';

import styles from './index.module.css';

export const ModalBase = ({isOpen, setModal, children}) => {

  useEffect(() => {
    if (isOpen) {
      disableScroll();
    }
  }, [isOpen]);

  const handleClose = () => {
    setModal({isOpen: false});
    enableScroll();
  };

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div
          className={styles.closeButton}
          onClick={handleClose}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.0001 13.4143L19.293 20.7072L20.7072 19.293L13.4143 12.0001L20.7072 4.70718L19.293 3.29297L12.0001 10.5859L4.70718 3.29297L3.29297 4.70718L10.5859 12.0001L3.29297 19.293L4.70718 20.7072L12.0001 13.4143Z" fill="#AFAFAF" />
          </svg>
        </div>
        {children}
      </div>
      <div
        onClick={handleClose}
        className={styles.backDrop}
      />
    </div>
    , document.body);
};
